import Badge from "../../../components/ui/Badge";
import { cx } from "../../../utils/classNames";
import { SOURCE_LABELS } from "../sessionUtils";
import OvertimeTag from "../../overtime/OvertimeTag";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Sessions.module.css";

// Badges for a month-summary day: approved overtime, check-in count,
// periods waiting for validation, and where the record came from (biometrics / HR).
//   showOvertime: false where overtime has its own column (Attendance list)
export const DayFlags = ({ record, showOvertime = true }) => {
  if (!record) return null;
  const showSource =
    record.source === "BIOMETRIC" || record.source === "MANUAL";

  return (
    <span className={styles.dayFlags}>
      {showOvertime && <OvertimeTag day={record} />}
      {record.sessionCount > 1 && (
        <Badge tone="gray" icon="bi-signpost-split">
          {record.sessionCount} check-ins
        </Badge>
      )}
      {record.forReviewCount > 0 && (
        <Badge tone="amber" icon="bi-hourglass-split">
          {record.forReviewCount > 1
            ? `${record.forReviewCount} for review`
            : "For review"}
        </Badge>
      )}
      {showSource && (
        <Badge tone="purple">{SOURCE_LABELS[record.source]}</Badge>
      )}
    </span>
  );
};

export const ViewLocationsButton = ({ record, onClick, className }) =>
  record?.id && record.hasLocation && onClick ? (
    <button
      type="button"
      className={cx(ui.linkButton, ui.noWrap, className)}
      onClick={() => onClick(record.id)}
      title="Where you checked in and out"
    >
      <i className="bi bi-geo-alt me-1"></i>
      View locations
    </button>
  ) : null;
